import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar as BootstrapNavbar, Nav, Container } from 'react-bootstrap';

function Navbar() {
  const location = useLocation();

  return (
    <BootstrapNavbar expand="lg" className="navbar-custom">
      <Container fluid>
        <BootstrapNavbar.Brand as={Link} to="/" className="fw-bold text-white me-3">
          حمد المنيف
        </BootstrapNavbar.Brand>
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" className="custom-toggler" />
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto"> {/* Changed me-auto to ms-auto for RTL alignment */}
            <Nav.Link as={Link} to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>
              الرئيسية
            </Nav.Link>
            <Nav.Link as={Link} to="/about" className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}>
              السيرة الذاتية
            </Nav.Link>
            <Nav.Link as={Link} to="/works" className={`nav-link ${location.pathname === '/works' ? 'active' : ''}`}>
              مشاريع
            </Nav.Link>
            <Nav.Link as={Link} to="/blog" className={`nav-link ${location.pathname === '/blog' ? 'active' : ''}`}>
              المدونة
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}>
              اتصل بنا
            </Nav.Link>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
}

export default Navbar;